import { AxiosError, AxiosResponse } from 'axios';
import api from '../../config/index';
import FilterTagPrintingList from '~/@core/domain/filters/tag/FilterTagPrintingList';
import { TagByProduct } from '~/@core/domain/model/tag';
import DefaultPaginated from '~/@core/domain/@shared/DefaultPaginated';

export const getTagsByProduct = (params: FilterTagPrintingList) => {
  return new Promise<DefaultPaginated<TagByProduct[]>>((resolve, reject) => {
    api
      .get<void, AxiosResponse<DefaultPaginated<TagByProduct[]>>>(
        '/tags/by-order',
        {
          params
        }
      )
      .then((response: AxiosResponse<DefaultPaginated<TagByProduct[]>>) => {
        resolve(response.data);
      })
      .catch((error: AxiosError) => {
        reject(error);
      });
  });
};
